


















import { Vue, Component, Prop } from 'vue-property-decorator'
import { getList } from '@/api/springexam/springexam'
import { randKey } from '@/utils/random'
import { SpringExam } from '@/models/springexam/SpringExam'

@Component
export default class ExamSelect extends Vue {
  @Prop({ type: String }) exam!: number
  exams = [] as SpringExam[]
  randKey = randKey()
  loading = true

  async created() {
    this.exams = await (await getList()).rows
    if (this.exams.length > 0)
      this.handleSelectChange(this.exams[0].id as string)
    this.loading = false
  }

  handleSelectChange(id: string) {
    this.$emit('update:exam', id)

    const exam = this.exams.find(a => a.id === id)
    if (exam) this.$emit('change', exam)
  }
}
